import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useMemo } from 'react';
import WrapPage from '@/components/base/Layout/wrap';
import Table from '@/components/base/Table';
import styled from 'styled-components';
import SimpleTable from '@/components/combined/SimpleTable';
import { Banner } from '@/components/combined/MasterBlockListTable';
import { getShardBlockNormalColumns, makeShardBlockColumns } from '@/constants/Block';
import Icon from '@/components/base/Icon';
import useLanguage from '@/hooks/useLanguage';
import getBlockServices from '@/api/blocks';
import getOverview from '@/api/overview';
import toasty from '@/components/base/Toast';
import { BLOCKLIST_PAGE_SIZE } from '@/utils/constants';
import Bubbles from '@/components/base/Spin/Bubbles';
import { globalShardFirst } from '@/utils/shard';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
var overviewService = getOverview();
var BlocksStyled = styled.div.withConfig({
    displayName: "blocks__BlocksStyled",
    componentId: "sc-2ppkpu-0"
})([
    "",
    " .header{",
    " .title{",
    " .first{",
    "}}.desc{",
    "}}"
], {
    "marginBottom": "24px",
    "marginTop": "26px"
}, {
    "marginBottom": "12px",
    "position": "relative",
    "display": "flex"
}, {
    "fontSize": "24px",
    "lineHeight": "29px",
    "fontWeight": "600",
    "display": "flex",
    "alignItems": "center",
    "flex": "1 1 0%"
}, {
    "color": "var(--color-desc-text)",
    "marginLeft": "9px",
    "marginRight": "9px",
    "fontSize": "14px",
    "fontWeight": "400"
}, {
    "fontSize": "14px",
    "lineHeight": "17px",
    "color": "var(--color-desc-text)",
    "display": "flex",
    "alignItems": "center",
    "marginRight": "10px",
    "alignSelf": "flex-end"
});
var blockService = getBlockServices();
var PAGE_SIZE = BLOCKLIST_PAGE_SIZE;
var Blocks = function() {
    var ref7;
    var translate = useLanguage().translate;
    var router = useRouter();
    var ref1 = useState('--'), height = ref1[0], setHeight = ref1[1];
    var ref2 = useState([]), masterBlocks = ref2[0], setMasterBlocks = ref2[1];
    var ref3 = useState(false), blocksLoading = ref3[0], setBlocksLoading = ref3[1];
    var ref4 = useState(false), blockExpandLoading = ref4[0], setBlockExpandLoading = ref4[1];
    var ref5 = useState(0), total = ref5[0], setTotal = ref5[1];
    var ref6 = useState(Number(router === null || router === void 0 ? void 0 : (ref7 = router.asPath) === null || ref7 === void 0 ? void 0 : ref7.split('#')[1]) || 1), pos1 = ref6[0], setPos = ref6[1];
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh) {
            getBlocks(pos1);
        }
    }, [
        refresh,
        pos1
    ]);
    useEffect(function() {
        getBlocks(pos1);
    }, [
        pos1
    ]);
    var getBlocks = useCallback(function(pos) {
        setBlocksLoading(true);
        return blockService.getMasterBlocks({
            limit: PAGE_SIZE,
            pos: (pos - 1) * PAGE_SIZE
        }).then(function(response) {
            var Result = response.Result;
            var ref = Result || {}, ListData = ref.ListData, TotalNum = ref.TotalNum;
            setTotal(TotalNum || 0);
            setMasterBlocks(ListData);
        }).catch(function(ex) {
            return toasty({
                type: 'error',
                content: ex.Message
            });
        }).finally(function() {
            return setBlocksLoading(false);
        });
    }, [
        pos1
    ]);
    var expandedBlockRowRender = useCallback(function(record) {
        return(/*#__PURE__*/ _jsx(SimpleTable, {
            data: record.expandable || [],
            columns: makeShardBlockColumns({
                expandable: 'block'
            }),
            indicator: /*#__PURE__*/ _jsx(Bubbles, {}),
            tableLayout: "fixed",
            showHeader: false,
            loading: record.expandable === undefined,
            rowKey: "ShardIndex"
        }));
    }, [
        masterBlocks,
        blockExpandLoading
    ]);
    var handleBlockExpand = useCallback(function(expanded, record) {
        if (expanded) {
            setBlockExpandLoading(true);
            blockService.getShardBlocks({
                height: record.Height
            }).then(function(response) {
                var Status = response.Status, Result = response.Result;
                if (Status === 0) {
                    var ListData = (Result || {}).ListData;
                    record.expandable = globalShardFirst(ListData);
                    return;
                }
            }).finally(function() {
                return setBlockExpandLoading(false);
            });
            return;
        }
    }, [
        masterBlocks
    ]);
    var paginationOption = useMemo(function() {
        return {
            current: pos1,
            pageSize: PAGE_SIZE,
            total: total,
            onPageChange: function(current) {
                setPos(current);
                router.push({
                    hash: current.toString()
                });
            }
        };
    }, [
        total,
        pos1
    ]);
    useEffect(function() {
        overviewService.getOverview().then(function(r) {
            var Height = (r.Result || {}).Height;
            setHeight(String(Height));
        });
    }, []);
    return(/*#__PURE__*/ _jsxs(BlocksStyled, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "title ",
                        children: [
                            translate('Blocks'),
                            /*#__PURE__*/ _jsx("span", {
                                className: "first block",
                                children: /*#__PURE__*/ _jsx(Banner, {
                                    onClick: function() {
                                        return getBlocks(pos1);
                                    },
                                    currentHeight: height
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "desc font-[400]",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                type: "bar",
                                className: "mr-[8px] text-[16px]"
                            }),
                            translate('%s Blocks', [
                                total
                            ])
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Table, {
                columns: getShardBlockNormalColumns(),
                data: masterBlocks,
                rowKey: function(record) {
                    return String(record.Height) + record.Timestamp;
                },
                loading: blocksLoading,
                tableLayout: "fixed",
                className: "cursor-pointer",
                skeletonRows: BLOCKLIST_PAGE_SIZE,
                expandable: {
                    expandRowByClick: true,
                    expandedRowRender: expandedBlockRowRender,
                    onExpand: handleBlockExpand,
                    showExpandColumn: true,
                    expandIcon: function(param) {
                        var record = param.record, onExpand = param.onExpand, expanded = param.expanded;
                        /*#__PURE__*/ return _jsx(Icon, {
                            onClick: function(e) {
                                return e && onExpand(record, e);
                            },
                            type: expanded ? 'unexpand' : 'expand',
                            size: 20
                        });
                    }
                },
                pageOpt: paginationOption
            })
        ]
    }));
};
export default WrapPage(observer(Blocks));
